<template>

    <el-container
            class="UserLayout"
            :class="{ 'UserLayout--menuOpened': menuOpened }"
    >
<canvas id="canvasSFC" :width="wEcran" :height="hEcran"></canvas>
        <div class="UserLayout-overlay" @click="() => setMenuOpened(false)"/>
        <el-header
                :height="browserContext.down('sm') ? '100px' : '50px'"
                class="UserLayout-header"
                v-if="browserContext.up('md') || onIndex"
        >
            <global-header @doUserCommand="doUserCommand"/>
        </el-header>
        <el-container>
            <el-aside
                    :width="menuOpened || browserContext.up('xl') ? '316px' : '50px'"
                    v-if="browserContext.up('md')"
                    class="UserLayout-aside"
            >
                <el-container>
                    <el-header
                            :height="browserContext.up('xl') ? '144px' : '128px'"
                            class="UserLayout-asideHeader"
                    >
                        <aside-header :widthDesktop="menuOpened || browserContext.up('xl')"/>
                    </el-header>
                    <el-main class="UserLayout-menu">
                        <main-menu :widthDesktop="menuOpened || browserContext.up('xl')"/>
                        <MenuTutoralsVideos v-if="$route.name === 'tutoralsVideos'" :widthDesktop="menuOpened || browserContext.up('xl')" />
                    </el-main>
                </el-container>
            </el-aside>
            <div class="UserLayout-content">
                <header
                        class="UserLayout-mobileMenu"
                        v-if="browserContext.down('sm') && onIndex"
                >
                    <mobile-menu/>
                </header>
                <main class="UserLayout-main">
                    <router-view/>
                </main>
                <footer class="UserLayout-footer" height="auto">
                    <social-links
                            class="UserLayout-footer-links"
                            v-if="browserContext.down('sm')"
                    />
                    <page-footer/>
                </footer>
            </div>
        </el-container>
        <mobile-footer
                class="UserLayout-mobileFooter"
                v-if="browserContext.down('sm')"
        />

        <el-dialog
                :title="$t('dashboard.txtTitrePopupSFC')"
                :visible.sync="isSFCPopupVisible"
                :modal="false"
                id="dialogueSFC"
                @close="cancelPopupDemarrageSFC"
        >
            <div text-align="justify" v-html="$t('dashboard.txtPopupSFC')" />
            <br/>
            <p style="color: dimgrey;font-size: small">
                <el-checkbox v-model="iUnderstandSfc">{{ $t('dashboard.txtChekboxPopupSFC') }}</el-checkbox>
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="cancelPopupDemarrageSFC">{{ $t('posts.dialog.cancel') }}</el-button>
                <el-button type="primary" @click="closePopupDemarrageSFC">Ok</el-button>
            </span>
        </el-dialog>

    </el-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import MainMenu from './MainMenu.vue'
import MobileMenu from './MobileMenu.vue'
import GlobalHeader from './GlobalHeader.vue'
import AsideHeader from './AsideHeader.vue'
import PageFooter from './PageFooter.vue'
import MobileFooter from './MobileFooter.vue'

import SocialLinks from './menu/SocialLinks.vue'
import { loadDefinitionDonneesLabels } from '../services/posts'
import VueAdBlockDetect from 'vue-adblock-detect'
import { putStopPopupSfc } from '../services/users'
import MenuTutoralsVideos from '@/pages/tutorals/MenuTutoralsVideos'

export default {
  name: 'UserLayout',
  mixins: [VueAdBlockDetect],
  components: {
    MenuTutoralsVideos,
    GlobalHeader,
    AsideHeader,
    MainMenu,
    PageFooter,
    MobileMenu,
    MobileFooter,
    SocialLinks
  },
  inject: ['browserContext'],
  metaInfo () {
    return {
      title: (this.$route.meta && this.$route.meta.title) || this.$route.name,
      titleTemplate: '%s | ' + this.$t('layouts.titleTemplate')
    }
  },
  data () {
    return {
      userLoading: true,
      boutonSFC: '',
      iUnderstandSfc: null
    }
  },
  computed: {
    ...mapGetters('productLine', ['hasLocalSeo']),
    user: {
      get () {
        return this.$store.getters.getUser
      },
      set (user) {
        this.setUser(user)
      }
    },
    language: {
      get () {
        return this.$store.getters.getLangage
      },
      set (newLanguage) {
        this.setLanguage(newLanguage)
      }
    },
    onIndex () {
      return this.$route.path === '/'
    },
    menuOpened () {
      return this.$store.getters.getMenuOpened
    },
    hEcran () {
      return window.innerHeight
    },
    wEcran () {
      return window.innerWidth
    },
    popupSfcVue () {
      return this.$store.getters.getPopupSfcVue
    },
    isSFCPopupVisible () {
      return !(this.user.stopPopupSfc === true || this.popupSfcVue === true) && this.hasLocalSeo
    }
  },
  methods: {
    ...mapActions(['setLanguage', 'setUser', 'unsetUser', 'setMenuOpened']),
    doUserCommand (command) {
      this[command]()
    },
    async signOut () {
      await this.$router.push({name: 'login', params: {signout: true}})
    },
	  myEventHandler () {
		  // recupération du bouton SFC
		  const boutonSFC = document.getElementById('idBoutonSFC')
      const infosBoutonSFC = boutonSFC.getBoundingClientRect()

		  // On récupère le Canvas
		  const canvas = document.getElementById('canvasSFC')
      canvas.style.overflowY = 'hidden'
      let ctxInfosBoutonSFC
      ctxInfosBoutonSFC = {
        x: infosBoutonSFC.x,
			  y: infosBoutonSFC.y,
			  w: infosBoutonSFC.width,
			  h: infosBoutonSFC.height
      }

      const ctx = canvas.getContext('2d')
      ctx.beginPath()
      ctx.fillStyle = 'black'
      ctx.fillRect(0, 0, canvas.offsetWidth, canvas.offsetHeight)
      ctx.clearRect(ctxInfosBoutonSFC.x, ctxInfosBoutonSFC.y, ctxInfosBoutonSFC.w, ctxInfosBoutonSFC.h)
    },
    blockScrolling () {
      if (!this.popupSfcVue) {
        window.scrollTo(0, 0)
      }
    },
    cancelPopupDemarrageSFC () {
      this.$store.commit('setPopupSfcVue', true)
      this.hideSFCCanvas()
    },
    async closePopupDemarrageSFC () {
      this.loading = true

      if (this.iUnderstandSfc) {
        const result = await putStopPopupSfc(this.user)
        if (result.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
        }
      }

      this.cancelPopupDemarrageSFC()
      this.loading = false
    },
    showSFCCanvas () {
      window.addEventListener('resize', this.myEventHandler)
      window.addEventListener('scroll', this.blockScrolling)
      this.myEventHandler()
    },
    hideSFCCanvas () {
      document.getElementById('canvasSFC').style.display = 'none'
      window.removeEventListener('resize', this.myEventHandler)
      window.removeEventListener('scroll', this.blockScrolling)
    }
  },
  beforeMount () {
    // we load the labels of all DefinitionDonnees globally here to load it for desktop / mobile
    // and in order to avoid the loading on the login page that creates a call to the api getting an error.
    loadDefinitionDonneesLabels()
    this.detectAdBlock().then((response) => {
      if (response) {
        this.$alert(this.$t('layouts.dactivateAdBlock'), this.$t('layouts.warning'), {
          confirmButtonText: 'OK'
        })
      }
    })
  },
  mounted () {
    if (this.isSFCPopupVisible) {
      this.showSFCCanvas()
    } else {
      this.hideSFCCanvas()
    }
  }
}
</script>

<style lang="scss">
    @import "@/theme/_bootstrap.scss";

    .UserLayout {
        display: block;
        background-repeat: no-repeat;
        background-attachment: fixed;

        &::before {
            content: "";
            background-color: #1e4a56;
            background-image: url("~@/assets/header.png");
            @include image-retina("~@/assets/header@2x.png", 2304px, 194px);
            background-position: 0 0;
            background-repeat: no-repeat;
            background-attachment: fixed;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            height: 178px;
            z-index: -1;
        }

        &-menu {
            padding: 0;
            margin-top: map-get($spacers, 3);
            overflow: hidden;
        }

        &-header {
            background-color: #1e4a56;
            background-image: url("~@/assets/header.png");
            @include image-retina("~@/assets/header@2x.png", 2304px, 194px);
            background-repeat: no-repeat;
            padding: 0;
            position: sticky;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1099;
        }

        &-aside {
            bottom: 0;
            left: 0;
            position: fixed;
            top: 50px;
            transition: width 0.3s;
            z-index: 1098;
            overflow: hidden;

          &:hover {
            overflow-y: scroll;
          }
        }

        &-asideHeader {
            padding: 0;
            position: sticky;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1099;

            background-image: url("~@/assets/header.png");
            @include image-retina("~@/assets/header@2x.png", 2304px, 194px);
            background-position: 0 -50px;
            background-repeat: no-repeat;
        }

        &-main,
        &-footer {
            margin-left: 316px;
        }

        &-content {
            width: 100%;
            margin: 0 !important;
            padding: 0 !important;
        }

        &-footer {
            @extend .px-4;
            text-align: center;

            &-links {
                @extend .my-5;
            }
        }

        @include media-breakpoint-up(md) {
            .responsive-main {
                width: 640px;
                margin: 0 auto;
            }
        }

        @include media-breakpoint-up(lg) {
            .responsive-main {
                width: 1080px;
                margin: 0 auto;
            }
        }

        @include media-breakpoint-down(lg) {
            background-image: url("~@/assets/header_background.jpg");
            @include image-retina("~@/assets/header_background@2x.jpg", 1300px, 178px);

            &-main,
            &-footer {
                margin-left: 50px;
            }

            &-menu {
                margin-top: 0;

                &::before {
                    background: $body-bg;
                    bottom: 0;
                    content: "";
                    left: 0;
                    position: fixed;
                    top: 0;
                    transition: width 0.3s, background 0.2s 0.1s;
                    width: 50px;
                    z-index: -1;
                }
            }
        }

        @include media-breakpoint-down(sm) {
            background: none;
            &::before {
                background: none;
            }

            &-mobileFooter {
                bottom: 0;
                left: 0;
                position: sticky;
                right: 0;
                z-index: 1099;
            }
            &-main {
                background: none;
                background-position: 0 0;
                margin-left: 0;
                width: 100%;
            }
            &-content {
                min-height: 100vh;
            }
        }

        &-overlay {
            background: transparent;
            bottom: 0;
            content: "";
            left: 0;
            position: fixed;
            right: 0;
            top: 0;
            z-index: 1097;
            pointer-events: none;
            transition: background 0.3s;
        }

        &--menuOpened {
            .UserLayout-overlay {
                background: rgba(0, 0, 0, 0.9);
                pointer-events: initial;
            }

            .UserLayout-menu {
                &::before {
                    background: $white;
                    transition: width 0.3s, background 0.1s;
                    width: 316px;
                }
            }
        }
    }

    #canvasSFC {
        position: absolute;
        margin: 0;
        z-index: 1500;
        opacity: 0.33;
    }
</style>
